import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";
import { BlogCard } from "@/components/BlogCard";
import { useApp } from "@/context/AppContext";

export const useSeo = (title, description) => {
  useEffect(() => {
    const prev = document.title;
    if (title) document.title = title;
    let tag = document.querySelector('meta[name="description"]');
    const prevDesc = tag?.getAttribute("content");
    if (description) {
      if (!tag) { tag = document.createElement("meta"); tag.setAttribute("name", "description"); document.head.appendChild(tag); }
      tag.setAttribute("content", description);
    }
    return () => { document.title = prev; if (tag && prevDesc != null) tag.setAttribute("content", prevDesc); };
  }, [title, description]);
};

export default function Blog() {
  const { data, loading } = useApp();
  const [params, setParams] = useSearchParams();
  const [cat, setCat] = useState(params.get("category") || "all");
  useSeo("Blogs — Archedia Solutions", "Bengaluru real-estate articles, micro-market guides and the Archedia property perspective.");

  const cats = data.blogCategories || [];
  const posts = useMemo(() => (data.blogs || []).filter((b) => cat === "all" || b.category === cat), [data.blogs, cat]);
  const pick = (c) => { setCat(c); setParams(c === "all" ? {} : { category: c }); };

  return (
    <div className="container-arch pt-28 pb-24" data-testid="blog-page">
      <Reveal>
        <div className="overline">Blogs</div>
        <h1 className="mt-3 font-serif text-4xl font-light text-[var(--text-primary)] sm:text-5xl">Perspective, written down.</h1>
        <p className="mt-3 max-w-xl text-[var(--text-muted)]">Bengaluru decoded, market reads and the thinking behind every Archedia recommendation.</p>
      </Reveal>

      <div className="mt-8 flex flex-wrap gap-2" data-testid="blog-categories">
        <button onClick={() => pick("all")} data-testid="blog-cat-all" className={`rounded-full border px-4 py-1.5 text-xs font-medium transition ${cat === "all" ? "border-[var(--accent-gold)] bg-[var(--accent-gold)] text-white" : "border-[var(--border-subtle)] text-[var(--text-primary)] hover:border-[var(--accent-gold)]"}`}>All</button>
        {cats.map((c) => (
          <button key={c.id} onClick={() => pick(c.name)} data-testid={`blog-cat-${c.slug}`} className={`rounded-full border px-4 py-1.5 text-xs font-medium transition ${cat === c.name ? "border-[var(--accent-gold)] bg-[var(--accent-gold)] text-white" : "border-[var(--border-subtle)] text-[var(--text-primary)] hover:border-[var(--accent-gold)]"}`}>{c.name}</button>
        ))}
      </div>

      {posts.length === 0 ? (
        <div className="mt-16 rounded-2xl border border-dashed border-[var(--border-subtle)] py-20 text-center" data-testid="blog-empty">
          <p className="font-serif text-2xl text-[var(--text-primary)]">{loading ? "Loading articles…" : "No articles in this category yet."}</p>
        </div>
      ) : (
        <Stagger className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {posts.map((p) => <StaggerItem key={p.id}><BlogCard post={p} /></StaggerItem>)}
        </Stagger>
      )}
    </div>
  );
}
